import trimEnd from "lodash/trimEnd"

export interface Environment extends ImportMetaEnv {
  API_URL: string
  POSTHOG_KEY: ""
  POSTHOG_HOST: ""
}

export const environment: Environment = {
  ...import.meta.env,
  API_URL: import.meta.env.VITE_API_URL
    ? trimEnd(import.meta.env.VITE_API_URL, "/ ")
    : "",
  POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY || "",
  POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST || "",
}
